// ? El objetivo es que en el futuro esta función nos permita manejar

// ? que el boleano se transforme a otros idiomas
export const activeBoolToText = (isBool: boolean) => (isBool ? 'Si' : 'No')

export function removeItemFromArrayByAttribute(
  arr: any[],
  attr: string,
  value: number
) {
  let i: number = arr.length
  while (i--) {
    if (
      arr[i] &&
      arr[i].hasOwnProperty(attr) &&
      arguments.length > 2 &&
      arr[i][attr] === value
    ) {
      arr.splice(i, 1)
    }
  }
  return arr
}

export function dynamicSort(property: any) {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a: any, b: any) {
    const result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export const simpleArraySum = (ar: any) => {
  let sum = 0
  for (let i = 0; i < ar.length; i++) {
    sum += ar[i]
  }
  return sum
}

export const getStepperContainerHeight = (offsetPx: number = 120) => {
  return `calc(100vh - ${offsetPx}px)`
}
